module.exports = __webpack_public_path__ + "img/ended.8b44eb1d.webp";